import { MsalAuthProvider, LoginType } from "react-aad-msal";
const applicationID = `${process.env.REACT_APP_CLIENT_ID}`;
const reactRedirectUri = `${process.env.REACT_APP_REDIRECT_URL}`;

const config: any = {
  auth: {
    authority: `${process.env.REACT_APP_AUTHORITY}`,
    clientId: applicationID,
    redirectUri: reactRedirectUri,
    validateAuthority: false,
    postLogoutRedirectUri: reactRedirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

const authenticationParameters = {
  scopes: ["openid", "profile"],
};

const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin + "/auth.html",
};
export const authProvider = new MsalAuthProvider(
  config,
  authenticationParameters,
  options
);
